import {
  FlattenInterpolation,
  Interpolation,
  SimpleInterpolation,
  ThemedStyledProps,
} from 'styled-components';

export enum MediaLabels {
  xs = 'smaller',
  sm = 'phone',
  md = 'tablet',
  lg = 'desktop',
}

export enum MediaAliases {
  smaller = 'xs',
  phone = 'sm',
  tablet = 'md',
  desktop = 'lg',
}

export type Media = MediaLabels | MediaAliases;

export type MediaTagFunction<
  P extends object = object,
  T extends object = object,
> = (
  strings: TemplateStringsArray | NonNullable<SimpleInterpolation>,
  ...interpolations: Interpolation<ThemedStyledProps<P, T>>[]
) => FlattenInterpolation<ThemedStyledProps<P, T>>;

export type MapMediaToQuery = { [Key in Media]: MediaTagFunction };

export type MediaObject = MapMediaToQuery & {
  min: MapMediaToQuery;
  max: MapMediaToQuery;
};

export type Breakpoints = { [key in Media]: number };
export type BreakpointKeys =
  | keyof typeof MediaAliases
  | keyof typeof MediaLabels;

export type PartialBreakpoints = Partial<Breakpoints>;

export type GetBreakpointsFn = () => Breakpoints;
